@if (!readonly) {
  <div class="fieldset" [ngClass]="{'disabled' :disabled}">
    <div class="row g-1 g-md-4 datetime">
      <div #picker class="col input-group dropdown">
        <input [(ngModel)]="formattedDate" (ngModelChange)="onDateChange()" [ngModelOptions]="{updateOn: 'blur'}"
               [required]="required" (focus)="this.focus.emit($event)" (blur)="this.blur.emit($event)"
               [disabled]="disabled"
               [ngClass]="status === 'warning' ? 'warning' : status === 'error' ? 'error' : null"
               [id]="id ? id + '-date' : null" autocomplete="off" class="form-control validatable"
               placeholder="dd-mm-yyyy">
        <button class="btn btn-outline-secondary fa fa-calendar-alt rounded-end"
                data-bs-toggle="dropdown" (focus)="this.focus.emit($event)" type="button"></button>
        <div class="dropdown-menu dropdown-menu-end p-3" onclick="event.stopPropagation()">
          @if (showPicker) {
            <app-date-picker [date]="_calendarStartDate" [minDate]="_minDate"
                             (dateChanged)="onDatePickerChanged($event)"></app-date-picker>
          }
        </div>
      </div>
      @if (!dateOnly) {
        <div class="col-4 time">
          <app-search [(ngModel)]="time" [searchFunction]="searchTime" [placeholder]="'hh:mm'" class="h-100"
                      (ngModelChange)="onTimeChange($event)" [id]="id ? id + '-time' : null"
                      [required]="required" (focus)="this.focus.emit($event)" [disabled]="disabled"
                      [ngClass]="status === 'warning' ? 'warning' : status === 'error' ? 'error' : null"></app-search>
        </div>
      }
    </div>
  </div>
} @else {
  <span class="me-2 fa fa-clock text-secondary"></span> <span
    [ngClass]="{'text-secondary' : !dateOnly}">{{ timestamp | timestamp:'DD MMM [’]YY' }}</span> @if (!dateOnly) {
    <span
      class="ms-1 text-secondary">{{ timestamp | timestamp:'HH:mm' }}</span>
  }
}
